import { useEffect } from "react";

const SUFFIX = " | \uB2E4\uAC00\uCE58 \uB545\uC2E0\uB8B0";

export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title
      ? title + SUFFIX
      : "\uB2E4\uAC00\uCE58 \uB545\uC2E0\uB8B0 LandTrust \u2014 \uBFF5\uC744 \uC218 \uC788\uB294 \uD1A0\uC9C0 \uAC70\uB798 \uD50C\uB7AB\uD3FC";
  }, [title]);
}
